/* eslint-disable no-param-reassign */
import { withErrorContext } from ".";
import { Editor } from "slate";
import { ReactEditor } from "slate-react";

import { Tag } from "@livechat/design-system-react-components";

export function withVariables(editor: Editor): Editor {
  const { isInline, isVoid, markableVoid } = editor as ReactEditor;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  editor.isInline = (element: any) =>
    element.type === "htmlSnippet" || element.type === "textVariable" ? true : isInline(element);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  editor.isVoid = (element: any) =>
    element.type === "htmlSnippet" || element.type === "textVariable" ? true : isVoid(element);

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  editor.markableVoid = (element: any) =>
    element.type === "htmlSnippet" || element.type === "textVariable" || markableVoid(element);

  return editor;
}

export const ReactPart: import("./index").ReactPart = {
  renderElement(props, _editor, next) {
    if (props.element.type === "htmlSnippet" || props.element.type === "textVariable") {
      return (
        <Tag kind="purple" contentEditable={false} size="small">
          {props.element.label}
          {props.children}
        </Tag>
      );
    }
    return next(props);
  },
};

const pluginSpec: import("./index").PluginSpec = [withErrorContext(withVariables), ReactPart];

export default pluginSpec;
